import { templates, ReclamationTemplate } from "./templates";
import { useGetServiceInfo } from '../../Service/Hooks/ServiceManager';
import { useCallback } from "react";

export const useTemplateManager = (cisId?: string) => {

    const { data: dataService } = useGetServiceInfo(cisId ? cisId : "" );
  
    const getAllTemplate = (): ReclamationTemplate[] => {
        return templates;
    };

    const getTempleteById = useCallback((templateId: string, dataToInject?: Array<any>|undefined): ReclamationTemplate | undefined => {
        if (!templateId) {
            return undefined;
        }

        const templateFound = templates.find(t => t.id === templateId);

        if (!templateFound) {
            return undefined;
        }

        // Créer une copie du template pour ne pas modifier l'original
        let template = { ...templateFound, content: templateFound.content };

        // Attendre que dataService soit chargé
        if(dataService) {
            Object.keys(dataService).forEach((key) => {
                const placeholder = `{${key}}`;
                if (template.content) {
                    template.content = template.content.replaceAll(placeholder, (dataService as any)[key]);
                }
            });
        }

        if(dataToInject !== undefined && dataToInject !== null) {
            Object.keys(dataToInject).forEach((key) => {
                const placeholder = `{${key}}`;
                if (template && template.content) {
                    template.content = template.content.replaceAll(placeholder, (dataToInject as any)[key]);
                }
            });
        }

        return template;

    }, [dataService]);

    return { getAllTemplate, getTempleteById, dataService };
};